import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ARTWORKS } from "../data/site";

const STORAGE_KEY = "jgj_recently_viewed";
const MAX_ITEMS = 8;

export function trackRecentlyViewed(slug, id) {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const list = raw ? JSON.parse(raw) : [];
    const filtered = list.filter((x) => x.id !== id);
    filtered.unshift({ slug, id, at: Date.now() });
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify(filtered.slice(0, MAX_ITEMS))
    );
  } catch {
    /* ignore */
  }
}

export default function RecentlyViewed() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const list = raw ? JSON.parse(raw) : [];
      const resolved = list
        .map(({ slug, id }) => {
          const series = ARTWORKS[slug];
          const a = series?.items.find((x) => x.id === id);
          return a ? { slug, artwork: a, seriesLabel: series.label } : null;
        })
        .filter(Boolean);
      setItems(resolved);
    } catch {
      setItems([]);
    }
  }, []);

  if (items.length < 2) return null; // don't show if only 1 or 0 pieces viewed

  return (
    <section
      className="border-t border-[hsl(var(--rule))] bg-[hsl(var(--surface))]"
      data-testid="recently-viewed"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-14 md:py-20">
        <div className="flex items-end justify-between gap-6 mb-8">
          <div>
            <p className="label mb-2">Pick up where you left off</p>
            <h2 className="serif text-3xl md:text-4xl tracking-tight font-light">
              Recently viewed.
            </h2>
          </div>
          <Link
            to="/work"
            className="label link-underline whitespace-nowrap hidden md:inline-flex"
          >
            All work →
          </Link>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8">
          {items.slice(0, 4).map(({ slug, artwork, seriesLabel }) => (
            <Link
              key={artwork.id}
              to={`/work/${slug}/${artwork.id}`}
              className="art-card block group"
              data-testid={`recently-viewed-${artwork.id}`}
            >
              <div className="aspect-[4/5] overflow-hidden bg-background">
                <img
                  src={artwork.image}
                  alt={artwork.title}
                  className="art-img w-full h-full object-cover"
                />
              </div>
              <p className="serif italic text-lg mt-3">{artwork.title}</p>
              <p className="label mt-1">{seriesLabel}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
